import Api from 'entities/helpers/api';
import LocalApi from 'entities/helpers/local-api';
import { withTransientRetry } from 'entities/helpers/transient-retry';

/**
 * Execute a GraphQL query, retrying transient transport failures (SIG-826).
 * Mutations are never retried; terminal failures reject to the caller as on master.
 */
export const fetchFromGraphql = async (query, variables, queryName = null, local = false) => {
  const api = local ? LocalApi : Api;
  const data = JSON.stringify({ operationName: null, query, variables });
  const isMutation = /^\s*mutation\b/.test(query);

  const res = await withTransientRetry(() => api.GRAPHQL.GRAPHQL.post({ data }), {
    enabled: !isMutation,
    label: queryName ? `graphql:${queryName}` : 'graphql',
  });
  if (local) console.log('Local Response: \n', res); // eslint-disable-line no-console
  if (res?.data) {
    return res.data;
  } else {
    return res;
  }
};

export const fetchBasicContactInfo = async (contactId) => {
  const query = `query($id: BigInt!) {
    contact(id: $id) {
      id
      contact_attributes {
        name_full
      }
      profile_image {
        url
      }  
    }
  }`;

  const { contact } = await fetchFromGraphql(query, { id: contactId }, 'contact');
  return contact;
};

export const gqlCall = (query, variables) =>
  Api.GRAPHQL.GRAPHQL.post({
    data: JSON.stringify({
      operationName: null,
      query: String.raw`${query}`,
      variables,
    }),
  });
